<script setup lang="ts">
import KSwitchField from '@/components/fields/KSwitchField.vue';
</script>

<template>
  <div class="mt-4 flex w-128 items-end justify-between">
    <div class="flex flex-col">
      <h4 class="m-0 p-0 font-semibold">Page view</h4>
      <p class="m-0 p-0">Enable tab version for Job Detailed page</p>
    </div>
    <div>
      <KSwitchField inset :hide-details="true" disabled />
    </div>
  </div>
  <div class="mt-4 flex w-128 items-end justify-between">
    <div class="flex flex-col">
      <h4 class="m-0 p-0 font-semibold">Access to the portal</h4>
      <p class="m-0 p-0"
        >Allow access to all pages related to a customer booking</p
      >
    </div>
    <div>
      <KSwitchField inset :hide-details="true" disabled />
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss"></style>
